import { UserActionItem } from 'ng2-app/modules/today/models/userActionItem.model';
import { FunnelUsers } from 'ng2-app/modules/funnel/models/funnel-users';
import { LenderUser } from 'ng2-app/models/dto/lender-user.model';
import { Document } from 'app/models/dto/document.model';
import { UserActionItemDetails } from 'ng2-app/modules/today/models/userActionItemDetails.model';
import {TaskComment} from 'lendio-borrower/models/task-comment/task-comment.model';

export class CheckNewLeadCallTask {
  static readonly type = '[UserActionItems] CheckNewLeadCallTask';
  constructor(
    public lenderUserId: number,
    public borrowerId: number,
  ) {}
}

export class SetUserActionItemsUser {
  static readonly type = '[UserActionItems] SetUserActionItemsUserId';
  constructor(
    public user: FunnelUsers | LenderUser,
  ) {}
}

export class UnsetActiveUserActionItem {
  static readonly type = '[UserActionItems] UnsetActiveUserActionItem';
  constructor() {}
}

export class GetUserActionItems {
  static readonly type = '[UserActionItems] GetUserActionItems';
  constructor(
    public reset: boolean = true,
    public types: Array<number> = [],
    public sortDirection: string = 'desc',
    public completed: boolean = false,
  ) {}
}

export class GetUserActionItemTypes {
  static readonly type = '[UserActionItems] GetUserActionItemTypes';
  constructor() {}
}

export class SubscribeToCompletedUserActionItems {
  static readonly type = '[UserActionItems] SubscribeToCompletedUserActionItems';
  constructor(
    public lenderUser: LenderUser,
  ) {}
}

export class UnsubscribeFromCompletedUserActionItems {
  static readonly type = '[UserActionItems] UnsubscribeFromCompletedUserActionItems';
  constructor(
    public lenderUser: LenderUser,
  ) {}
}

export class GetUserActionItemDetails {
  static readonly type = '[UserActionItemDetail] GetUserActionItemDetails';
  constructor(public actionItemId: number) {}
}

export class SetUserActionItemDetails {
  static readonly type = '[UserActionItemDetail] SetUserActionItemDetails';
  constructor(
    public actionItemDetails: UserActionItemDetails
  ) {}
}

export class CreateActionItemTaskComment {
  static readonly type = '[UserActionItemDetail] CreateActionItemTaskComment';
  constructor(
    public commentModel: Partial<TaskComment>,
    public actionItem: UserActionItem,
  ) {}
}

export class SetSelectedTabByName {
  static readonly type = '[UserActionItemDetail] SetSelectedTabIndex';
  constructor(public tabName: string) {}
}

export class SetTodayTabs {
  static readonly type = '[UserActionItemDetail] SetTodayTabs';
  constructor(public tabs: Array<string>) {}
}

export class CompleteTask {
  static readonly type = '[UserActionItemDetail] CompleteTask';
  constructor(
    public taskId: number,
    public taskTypeId: number,
    public lenderUserId: number
  ) {}
}

export class SendToFundingDesk {
  static readonly type = '[UserActionItems] SendToFundingDesk';
  constructor(public borrower: {
    borrowerId: number;
    borrowerName: string;
  }) {}
}

export class GetKickbackCount {
  static readonly type = '[UserActionItems] GetKickbackCount';
  constructor(public borrowerId: number) {}
}

export class ClearKickbackCount {
  static readonly type = '[UserActionItems] ClearKickbackCount';
  constructor() {}
}

export class ActionItemTaskCompleted {
  static readonly type = '[UserActionItems] ActionItemTaskCompleted';
  constructor(
    public taskId: number,
    public borrowerKickback?: {
      borrowerId: number;
      borrowerName: string;
      kickback: string | null;
    }
  ) {}
}

export class DispatchBorrowerContextActions {
  static readonly type = '[UserActionItemDetail] DispatchBorrowerContextActions';
  constructor(
    public borrowerId: number,
  ) {}
}

export class UpdateDocument {
  static readonly type = '[UserActionItemDetail] UpdateDocument';
  constructor(
    public document: Document,
    public userId: number,
  ) {}
}

export class ProcessDocument {
  static readonly type = '[UserActionItemDetail] ProcessDocument';
  constructor(
    public document: Document,
    public userId: number,
    public borrowerId: number
  ) {}
}

export class UpdateAndProcessDocument {
  static readonly type = '[UserActionItemDetail] UpdateAndProcessDocument';
  constructor(
    public document: Document,
    public userId: number,
    public borrowerId: number
  ) {}
}

export class ViewDocumentReviewTaskByDocId {
  static readonly type = '[UserActionItemDetail] ViewDocumentReviewTaskByDocId';
  constructor(
    public documentId: number,
  ) {}
}

export class MarkActionItemCompleted {
  static readonly type = '[UserActionItems] MarkActionItemCompleted';
  constructor(
    public id: number,
  ) {}
}
